import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MunilyReservationReviewCardData } from './reservation-review-card.types';

@Component({
  selector: 'common-reservation-review-card',
  templateUrl: './reservation-review-card.component.html',
  styleUrls: ['./reservation-review-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReservationReviewCardComponent {
  @Input() data!: MunilyReservationReviewCardData;
}
